export const FIELDS = {
  ID: 'id',
  STATUS_NAME: 'statusName',
  RMANO: 'rmaNo',
  RMADATE: 'rmaDate',
  CUSTOMER_PO: 'customerPo',
  STATUS_ID: 'statusId',
  COMPANY_NAME: 'companyName',
  CONTACT_FULL_NAME: 'contactFullName',
  RMAACTION_ID: 'rmaActionId',
  RMAACTION_NAME: 'rmaActionName',
  RMATERMS_ID: 'rmaTermsId',
  RMATERMS_NAME: 'rmaTermsName',
  COMPANY_ID: 'companyId',
  REP_NO: 'repNo',
  CONTACT_ID: 'contactId',
  CONTACT_EMAIL: 'contactEmail',
  COMPANY_INFO: 'companyInfo',
  BILLING_ADDRESS_ID: 'billingAddressId',
  BILLING_ADDRESS: 'billingAddress',
  SHIPPING_ADDRESS_ID: 'shippingAddressId',
  SHIPPING_ADDRESS: 'shippingAddress',
  SALES_PERSON_USER_ID: 'salesPersonUserId',
  SALES_PERSON_USER_FULL_NAME: 'salesPersonUserFullName',
  IS_AUTHORIZED: 'isAuthorized',
  AUTHORIZED_BY_USER_FULL_NAME: 'authorizedByUserFullName',
  SUB_TOTAL: 'subTotal',
  TOTAL_LINE_COST: 'totalLineCost',
  TOTAL_CHARGES_TAXABLE: 'totalChargesTaxable',
  TOTAL_CHARGES_NON_TAXABLE: 'totalChargesNonTaxable',
  TOTAL_CHARGES: 'totalCharges',
  TOTAL_CHARGES_COST: 'totalChargesCost',
  TOTAL: 'total',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  APPROVED_BY_USER_ID: 'approvedByUserId',
  APPROVED_BY_USER_FULL_NAME: 'approvedByUserFullName',
  RETURN_SHIPPING: 'returnShipping',
  IS_TAXABLE: 'isTaxable',
  TAX_RATE: 'taxRate',
  TOTAL_NO_CHARGE: 'totalNoCharge',
  TAX_DESCRIPTION: 'taxDescription',
  SUB_TOTAL_CONVERTED: 'subTotalConverted',
  TOTAL_LINE_COST_CONVERTED: 'totalLineCostConverted',
  TOTAL_CHARGES_TAXABLE_CONVERTED: 'totalChargesTaxableConverted',
  TOTAL_CHARGES_NON_TAXABLE_CONVERTED: 'totalChargesNonTaxableConverted',
  TOTAL_CHARGES_CONVERTED: 'totalChargesConverted',
  TOTAL_CHARGES_COST_CONVERTED: 'totalChargesCostConverted',
  TOTAL_CONVERTED: 'totalConverted',
  COMMENTS: 'comments',
  TAX: 'tax',
  TAXABLE: 'taxable',
  INVOICE_AMOUNT_PAID: 'invoiceAmountPaid',
  INVOICE_BALANCE: 'invoiceBalance',
  SYMBOL: 'symbol',
  BUYER_CURRENCY: 'buyerCurrency',
  CURRENCY_TYPE_ID: 'currencyTypeId',
  CURRENCY_TYPE_NAME: 'currencyTypeName',
  CURRENCY_SYMBOL: 'currencySymbol',
  EXCHANGE_RATE: 'exchangeRate',
  BUYER_SUB_TOTAL: 'buyerSubTotal',
  BUYER_RETURN_SHIPPING: 'buyerReturnShipping',
  BUYER_TOTAL_CHARGES: 'buyerTotalCharges',
  BUYER_VAT: 'buyerVat',
  BUYER_TAX: 'buyerTax',
  BUYER_TOTAL: 'buyerTotal',
  AUTHORIZED_BY_USER_ID: 'authorizedByUserId',
  DATE_AUTHORIZED: 'dateAuthorized',
  ACTIVE: 'active',
  CREDIT_MEMO_ID: 'creditMemoId',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  INVOICE_ID: 'invoiceId',};